<template>
    <div>
        <div class="row">
            <div class="col-12 px-0">
                <ul class="qf-dashboard-navigation">
                    <li class="qf-active-nav">
                        <a href="#!" @click.prevent>
                            {{isEdit ? $ml.get('edit_trademark') : $ml.get('add_trademark')}}
                        </a>
                    </li>
                    <li v-if="loaders.brandData">
                        <a @clisk.prevent>
                            <font-awesome-icon icon="spinner" class="fa-spin"/>
                        </a>
                    </li>
                    <li></li>
                </ul>
            </div>
        </div>
        <div class="row">
            <div class="col-12 pb-3">
                <a href="/dashboard" @click.prevent="$router.back()" class="small">&lt;&nbsp;{{$ml.get('Back')}}</a>
            </div>
        </div>
        <form @submit.prevent="saveBrand" ref="brandForm">
            <div class="row">
                <div class="col-12 col-md-6 mb-3">
                    <div class="qf-items-box">
                        <div class="row">
                            <div class="col-12">
                                <div class="row align-items-center p-3">
                                    <div class="col-12">{{$ml.get('Type')}}</div>
                                    <div class="col-12">
                                        <label class="mr-4 qf-radio qf-fs-90">
                                            <input type="radio" name="type" value="Audio"
                                                   v-model="formData.type">
                                            <span class="qf-radio-btn"></span>
                                            <span>{{$ml.get('type_audio')}}</span>
                                        </label>
                                        <label class="mr-4 qf-radio qf-fs-90">
                                            <input type="radio" name="type" value="Figurative with text element"
                                                   v-model="formData.type">
                                            <span class="qf-radio-btn"></span>
                                            <span>{{$ml.get('type_mixed')}}</span>
                                        </label>
                                        <label class="mr-4 qf-radio qf-fs-90">
                                            <input type="radio" name="type" value="Figurative"
                                                   v-model="formData.type">
                                            <span class="qf-radio-btn"></span>
                                            <span>{{$ml.get('type_figurative')}}</span>
                                        </label>
                                        <label class="mr-4 qf-radio qf-fs-90">
                                            <input type="radio" name="type" value="Verbal"
                                                   v-model="formData.type">
                                            <span class="qf-radio-btn"></span>
                                            <span>{{$ml.get('type_verbal')}}</span>
                                        </label>
                                        <label class="mr-4 qf-radio qf-fs-90">
                                            <input type="radio" name="type" value="3d" v-model="formData.type">
                                            <span class="qf-radio-btn"></span>
                                            <span>3D</span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="row align-items-center p-3">
                                    <div class="col-12">{{$ml.get('Kind')}}</div>
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col flex-grow-0 pt-2">
                                                <label class="mr-4 qf-radio qf-fs-90">
                                                    <input type="radio" name="kind" value="Individual"
                                                           v-model="formData.kind"
                                                           @change="showUploadCollectiveFile(false)">
                                                    <span class="qf-radio-btn"></span>
                                                    <span>{{$ml.get('kind_individual')}}</span>
                                                </label>
                                            </div>
                                            <div class="col flex-grow-0 pt-2">
                                                <label class="mr-4 qf-radio qf-fs-90">
                                                    <input type="radio" name="kind" value="Collective"
                                                           v-model="formData.kind"
                                                           @change="showUploadCollectiveFile(true)">
                                                    <span class="qf-radio-btn"></span>
                                                    <span>{{$ml.get('kind_collective')}}</span>
                                                </label>
                                            </div>
                                            <div class="col flex-grow-0" v-if="uploadCollectiveFile">
                                                <div class="qf-upload-file-box small">
                                                    <button type="button" class="btn btn-outline-dark"
                                                            @click="addNewRuleClick">
                                                        <font-awesome-icon icon="upload"/>
                                                        <span class="qf-icon-separator"></span>{{$ml.get('upload_file')}}
                                                    </button>
                                                    <!-- For uploading more than one file -> remove check for 'rules.length' and change css/design!!! -->
                                                    <div class="qf-add-rule-box">
                                                        <input type="file"
                                                               name="rule[]"
                                                               id="new_rule"
                                                               class="inputfile"
                                                               ref="newRule"
                                                               multiple
                                                               @change="addNewRule($event)"/>
                                                    </div>
                                                </div>
                                                <div v-for="(fileData, index) in fileInputs" :key="`fileData${index}`">
                                                    <label class="qf-rule-label">
                                                        {{fileData.name}}
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col flex-grow-1 pt-2" v-if="uploadCollectiveFile">
                                                <div class="pb-1 d-flex"
                                                     v-for="(file, index) in formData.rules"
                                                     :key="index">
                                                    <label :for="index" class="qf-rule-label"
                                                           :title="file.original_name"
                                                           :class="{'text-warning': inDeleteRules(file.id)}">
                                                        {{file.original_name ? file.original_name : file.file_name}}
                                                    </label>
                                                    <a :href="file.id | downloadLink(id)"
                                                       download=""
                                                       class="qf-custom-icon-btn pl-2"
                                                       :class="{'text-warning': inDeleteRules(file.id)}">
                                                        <font-awesome-icon icon="download"/>
                                                    </a>
                                                    <button type="button" @click="deleteRule(file.id)"
                                                            class="qf-custom-icon-btn pl-2"
                                                            :class="{'text-warning': inDeleteRules(file.id)}">
                                                        <font-awesome-icon icon="plus" v-if="inDeleteRules(file.id)"/>
                                                        <font-awesome-icon icon="trash-alt" v-else/>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="row align-items-center p-3">
                                    <div class="col-12">{{$ml.get('Tracking_Criteria')}}</div>
                                    <div class="col-12">
                                        <div class="pb-1">
                                            <div class="d-flex align-items-center">
                                                <div class="mr-1">
                                                    <label class="qf-checkbox">
                                                        <input type="checkbox" name="trackTitle"
                                                               id="trackByTitle"
                                                               v-model="formData.trackTitle">
                                                        <font-awesome-icon icon="check"/>
                                                    </label>
                                                </div>
                                                <div class="mr-4">
                                                    <label class="mb-0 qf-cursor-pointer qf-fs-90"
                                                           for="trackByTitle">
                                                        {{$ml.get('Title')}}
                                                    </label>
                                                </div>
                                                <div class="mr-1">
                                                    <label class="qf-checkbox">
                                                        <input type="checkbox" name="trackNice"
                                                               id="trackByNiceClasses"
                                                               v-model="formData.trackNice">
                                                        <font-awesome-icon icon="check"/>
                                                    </label>
                                                </div>
                                                <div class="mr-4">
                                                    <label class="mb-0 qf-cursor-pointer qf-fs-90"
                                                           for="trackByNiceClasses">
                                                        {{$ml.get('Nice_Classes')}}
                                                    </label>
                                                </div>
                                                <div class="mr-1">
                                                    <label class="qf-checkbox">
                                                        <input type="checkbox" name="trackVienna"
                                                               id="trackByViennaClasses"
                                                               v-model="formData.trackVienna">
                                                        <font-awesome-icon icon="check"/>
                                                    </label>
                                                </div>
                                                <div class="mr-4">
                                                    <label class="mb-0 qf-cursor-pointer qf-fs-90"
                                                           for="trackByViennaClasses">
                                                        {{$ml.get('Vienna_Classes')}}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 mb-3">
                    <div class="qf-dropzone">
                        <div class="qf-dropbox-content d-flex align-items-center justify-content-center"
                             :class="{'qf-dropbox-hover': fileDragOver}"
                             @dragenter="fileDragOver=true" @dragend="fileDragOver=false"
                             @dragleave="fileDragOver=false">
                            <div class="text-center p-3" v-if="!imageBase64">
                                <h5 class="text-uppercase">
                                    <strong v-html="$ml.get('Your_Logo_Here')"></strong>
                                </h5>
                                <div class="qf-chose-file">
                                    {{$ml.get('Chose_File')}}
                                </div>
                            </div>
                            <div class="text-center" v-else>
                                <img :src="imageBase64" class="img-fluid" alt="" v-if="imageBase64">
                                <font-awesome-icon v-if="imageBase64" icon="trash-alt" class="delete-icon" @click="deleteLogo(imageBase64)" />
                            </div>
                            <input type="file" name="logo" accept="image/*" @change="filesChange($event)">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row pt-4">
                <div class="col flex-grow-0">
                    <h6 class="text-uppercase qf-no-wrap">
                        {{$ml.get('Basic_Information')}}
                    </h6>
                </div>
                <div class="col flex-grow-1 align-self-center">
                    <hr class="mt-0 mb-2">
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="brandName" class="text-capitalize" style="font-size: 90%">{{$ml.get('Title')}}
                            *</label>
                        <input type="text" class="form-control" name="brandName" id="brandName"
                               :placeholder="$ml.get('Title')" v-model="formData.brandName"
                               v-validate="'required'"
                               :class="{'is-invalid': errors.has('brandName')}">
                        <small class="form-text text-danger pl-3"
                               v-if="formErrors.title.length">
                            {{formErrors.title}}
                        </small>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="owner" class="text-capitalize" style="font-size: 90%">{{$ml.get('Owner')}}
                            <font-awesome-icon icon="spinner" class="fa-spin" v-if="loaders.owners"/>
                        </label>
                        <div class="d-flex align-items-center">
                            <div class="flex-grow-1 mr-3">
                                <select id="owner" class="form-control" name="owner"
                                        v-model="formData.owner"
                                        v-validate="'required|excluded:-1'"
                                        :class="{'is-invalid': errors.has('owner')}">
                                    <option value="-1" disabled="disabled">{{$ml.get('Owner')}}</option>
                                    <option v-for="owner in owners" :value="owner.id"
                                            :key="`owner${owner.id}`">
                                        {{owner.name}}
                                    </option>
                                </select>
                                <small class="form-text text-danger pl-3"
                                       v-if="formErrors.owner.length">
                                    {{formErrors.owner}}
                                </small>
                                <!--<small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>-->
                            </div>
                            <div class="flex-grow-0 small qf-no-wrap">
                                <a href="#!" @click.prevent="openOwnersModal">
                                    <strong>+{{$ml.get('add')}}</strong>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label for="titleInput" class="text-capitalize" style="font-size: 90%">{{$ml.get('Trademark_Monitoring_Keywords')}}</label>
                        <tags-input
                                v-model="formData.title"
                                :element-id="'title'"
                                :inputId="'titleInput'"
                                :existing-tags="[]"
                                :typeahead="true"
                                :typeahead-style="'dropdown'"
                                :typeahead-activation-threshold="0"
                                :placeholder="$ml.get('Keywords')"
                        ></tags-input>
                    </div>
                </div>
            </div>
            <div class="row pt-4">
                <div class="col flex-grow-0">
                    <h6 class="text-uppercase qf-no-wrap">
                        {{$ml.get('Registration_Information')}}
                    </h6>
                </div>
                <div class="col flex-grow-1 align-self-center">
                    <hr class="mt-0 mb-2">
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <label for="applicationNumber" class="text-capitalize" style="font-size: 90%">{{$ml.get('Application_Number')}}
                            *</label>
                        <input type="text" class="form-control" name="applicationNumber"
                               id="applicationNumber" :placeholder="$ml.get('Application_Number')"
                               v-model="formData.applicationNumber" v-validate="'required'"
                               :class="{'is-invalid': errors.has('applicationNumber')}">
                        <small class="form-text text-danger pl-3"
                               v-if="formErrors.applicationNumber.length">
                            {{formErrors.applicationNumber}}
                        </small>
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <label for="applicationDate" class="text-capitalize" style="font-size: 90%">{{$ml.get('Application_Date')}}
                            *</label>
                        <vuejs-datepicker :monday-first="true" :bootstrap-styling="true"
                                          :typeable="true"
                                          calendar-class="qf-calendar-class" name="applicationDate"
                                          id="applicationDate"
                                          :placeholder="$ml.get('Application_Date')"
                                          :language="calendarLanguages.en"
                                          :format="customFormatter"
                                          v-model="formData.applicationDate"
                                          v-validate="'required'"
                                          :input-class="{'is-invalid': errors.has('applicationDate')}"></vuejs-datepicker>
                        <small class="form-text text-danger pl-3"
                               v-if="formErrors.applicationDate.length">
                            {{formErrors.applicationDate}}
                        </small>
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <label for="registerNumber" class="text-capitalize" style="font-size: 90%">{{$ml.get('Registration_Number')}}</label>
                        <input type="text" class="form-control" name="registerNumber"
                               id="registerNumber" :placeholder="$ml.get('Registration_Number')"
                               v-model="formData.registerNumber">
                        <!--<small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>-->
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <label for="registrationDate" class="text-capitalize" style="font-size: 90%">{{$ml.get('Date_Of_Registration')}}</label>
                        <vuejs-datepicker :monday-first="true" :bootstrap-styling="true"
                                          :typeable="true"
                                          calendar-class="qf-calendar-class" name="registrationDate"
                                          id="registrationDate"
                                          :format="customFormatter"
                                          :placeholder="$ml.get('Date_Of_Registration')"
                                          v-model="formData.registrationDate"></vuejs-datepicker>
                        <!--<small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>-->
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <label class="text-capitalize"
                               style="font-size: 90%"
                        >{{$ml.get('Country_Of_Registration')}}
                            *</label>
                        <multiselect v-model="countrySelect"
                                     :options="$countries"
                                     :custom-label="countrySelectCustom"
                                     :placeholder="$ml.get('Country_Of_Registration')"
                                     track-by="name"
                                     :allowEmpty="false"
                                    ></multiselect>
                        <input type="hidden" name="officeOfOrigin" v-model="countrySelect.code" v-validate="'required'">
                        <small class="form-text text-danger pl-3"
                               v-if="formErrors.officeOfOrigin.length">
                            {{formErrors.officeOfOrigin}}
                        </small>
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <label for="designatedContractingParty" class="text-capitalize" style="font-size: 90%">{{$ml.get('Designated_countries')}}
                            *</label>
                        <tags-input
                                v-model="formData.designatedCountry"
                                :element-id="'designatedCountry'"
                                :inputId="'designatedContractingParty'"
                                :existing-tags="countryTags"
                                :typeahead="true"
                                :typeahead-style="'dropdown'"
                                :typeahead-activation-threshold="0"
                                :typeaheadMaxResults="10"
                                :placeholder="$ml.get('Designated_countries')"
                        ></tags-input>
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <label for="expiredOn" class="text-capitalize" style="font-size: 90%">{{$ml.get('Expiration_Date')}}
                            *</label>
                        <vuejs-datepicker :monday-first="true" :bootstrap-styling="true"
                                          :typeable="true"
                                          calendar-class="qf-calendar-class" name="expiredOn"
                                          id="expiredOn"
                                          :placeholder="$ml.get('Expiration_Date')"
                                          :language="calendarLanguages.en"
                                          :format="customFormatter"
                                          v-model="formData.expiredOn"
                                          v-validate="'required'"
                                          :input-class="{'is-invalid': errors.has('expiredOn')}"></vuejs-datepicker>
                        <small class="form-text text-danger pl-3"
                               v-if="formErrors.expiredOn.length">
                            {{formErrors.expiredOn}}
                        </small>
                        <!--<small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>-->
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <label for="status" class="text-capitalize" style="font-size: 90%">
                            {{$ml.get('Status')}} *</label>
                        <select name="status"
                                id="status"
                                class="form-control"
                                v-validate="'required|excluded:0'"
                                :class="{'is-invalid': errors.has('status')}"
                                v-model="formData.status">
                            <option disabled value="0" selected>{{$ml.get('Select_status')}}</option>
                            <option v-for="(option, index) in selectOptions"
                                    :key="index" :value="option">
                                {{$ml.get(`status_${option}`)}}
                            </option>
                        </select>
                        <small class="form-text text-danger pl-3"
                               v-if="formErrors.status.length">
                            {{formErrors.status}}
                        </small>
                        <!-- <input type="text" class="form-control" name="status" id="status"
                                     :placeholder="$ml.get('Status')"
                                     v-model="formData.status"> -->
                    </div>
                </div>
            </div>
            <div class="row pt-4">
                <div class="col flex-grow-0">
                    <h6 class="text-uppercase qf-no-wrap">
                        {{$ml.get('Classes')}}
                    </h6>
                </div>
                <div class="col flex-grow-1 align-self-center">
                    <hr class="mt-0 mb-2">
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <label for="viennaClassesInput" class="text-capitalize" style="font-size: 90%">{{$ml.get('Vienna_Classes')}}</label>
                        <tags-input
                                v-model="formData.viennaClasses"
                                :element-id="'viennaClasses'"
                                :inputId="'viennaClassesInput'"
                                :existing-tags="[]"
                                :typeahead="true"
                                :typeahead-style="'dropdown'"
                                :typeahead-activation-threshold="0"
                                :placeholder="$ml.get('Vienna_Classes')"
                        ></tags-input>
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <label for="colors" class="text-capitalize"
                               style="font-size: 90%">{{$ml.get('Colors')}}</label>
                        <input type="text" class="form-control" name="colors" id="colors"
                               :placeholder="$ml.get('Colors')" v-model="formData.colors">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12" v-for="(niceClassRow, index) in formData.niceClasses"
                     :key="`niceClassRow${index}`">
                    <div class="form-group">
                        <div class="d-flex">
                            <div class="mr-3 flex-grow-0">
                                <label :for="`niceCLassNumber${index}`" class="text-capitalize"
                                       style="font-size: 90%">{{$ml.get('Number')}}</label>
                                <select class="form-control" style="height: 50px;"
                                        :id="`niceCLassNumber${index}`"
                                        @change="changeClass($event, index)"
                                        v-model="formData.niceClasses[index].value">
                                    <option v-for="(niceClass, classIndex) in niceClasses"
                                            :key="`niceClass${classIndex}`"
                                            :value="classIndex">
                                        {{classIndex}}
                                    </option>
                                </select>
                            </div>
                            <div class="mr-3 flex-grow-1">
                                <label :for="`niceCLassDescription${index}`" class="text-capitalize"
                                       style="font-size: 90%">{{$ml.get('Nice_Class')}}</label>
                                <textarea class="form-control qf-h-100px qf-resize-none qf-fs-90"
                                          :id="`niceCLassDescription${index}`"
                                          v-model="formData.niceClasses[index].description"></textarea>
                            </div>
                            <div class="flex-grow-0 small qf-no-wrap pt-4">
                                <a href="#!" @click.prevent="removeNiceClass(index)"><strong>-
                                    Remove</strong></a>
                            </div>
                            <!--<div class="flex-grow-0 small qf-no-wrap pt-4"><a href="#!"><strong>+ Add</strong></a></div>-->
                        </div>

                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group mb-0">
                        <small class="form-text text-danger pl-3"
                               v-if="formErrors.niceClasses.length">
                            {{formErrors.niceClasses}}
                        </small>
                        <a href="#!" class="btn btn-outline-dark text-uppercase btn-sm"
                           @click.prevent="addNiceClass">
                            <font-awesome-icon icon="plus"/>&nbsp;&nbsp;{{$ml.get('Add_Nice_Class')}}
                        </a>
                    </div>
                </div>
            </div>
            <div class="row pt-4">
                <div class="col flex-grow-0">
                    <h6 class="text-uppercase qf-no-wrap">
                        {{$ml.get('notes')}}
                    </h6>
                </div>
                <div class="col flex-grow-1 align-self-center">
                    <hr class="mt-0 mb-2">
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                    <textarea id="note" name="note" class="form-control qf-h-100px qf-resize-none qf-fs-90"
                              v-model="formData.note"
                              :placeholder="$ml.get('add_notes')"></textarea>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center pt-4" v-if="loading">
                <div class="col-12 text-center">
                    <font-awesome-icon icon="spinner" size="2x" class="fa-spin"/>
                </div>
            </div>
            <div class="row justify-content-center" v-else>
                <div class="col-4 text-right">
                    <a href="/dashboard" @click.prevent="$router.back()" class="btn btn-outline-dark">
                        <font-awesome-icon icon="times"/>&nbsp;&nbsp;&nbsp;{{$ml.get('Cancel')}}</a>
                </div>
                <div class="col-4">
                    <button class="btn btn-warning" type="submit">
                        <font-awesome-icon icon="save"/>&nbsp;&nbsp;&nbsp;{{$ml.get('Save')}}
                    </button>
                </div>
            </div>
            <div class="row justify-content-center align-items-center"
                 v-if="formErrors.generalError.length">
                <div class="col-5 form-group">
                    <small class="form-text text-danger">
                        {{$ml.get('general_error_msg')}}
                    </small>
                </div>
            </div>
        </form>

        <b-modal id="add-owner-modal"
                 v-model="showOwnerModal"
                 title="Add New Owner"
                 :hide-footer="true">
            <add-owner
                    @closeOwnersModal="closeOwnersModal"></add-owner>
        </b-modal>
    </div>
</template>

<script>
    import AddOwner from '../common/AddOwner'
    import TagsInput from '../common/TagsInput'
    import moment from 'moment'
    import {en, bg} from 'vuejs-datepicker/dist/locale'

    import {trademark_statuses} from '../../helpers/trademark-statuses'

    export default {
        name: "AddEditBrand",
        components: {
            AddOwner, TagsInput
        },
        props: {
            id: {
                type: String,
                default: ''
            }
        },
        filters: {
            downloadLink(ruleId, brandId) {
                return `${process.env.VUE_APP_API_URL}brand/${brandId}/rule/${ruleId}?access_token=${localStorage.getItem('user-token')}`
            }
        },
        computed: {
            countryTags() {
                return this.$countries.map(obj => {
                    return {key: obj.name, value: obj.name}
                });
            },
        },
        data() {
            return {
                countrySelect: { "name": "Bulgaria", "code": "BG" },
                isEdit: false,
                fileDragOver: false,
                imageBase64: null,
                calendarLanguages: {
                    en: en,
                    bg: bg
                },
                owners: [],
                niceClasses: [],
                showOwnerModal: false,
                viennaClasses: [],
                uploadCollectiveFile: false,
                collectiveFile: null,
                collectiveFileDragOver: false,
                formData: {
                    type: 'Figurative with text element',
                    kind: 'Individual',
                    brandName: '',
                    rule: [],
                    rules: [],
                    deletedRules: [],
                    title: [],
                    owner: -1,
                    niceClasses: [],
                    viennaClasses: [],
                    designatedCountry: [],
                    colors: '',
                    trackTitle: false,
                    trackNice: false,
                    trackVienna: false,
                    applicationNumber: '',
                    applicationDate: '',
                    registerNumber: '',
                    registrationDate: '',
                    expiredOn: '',
                    officeOfOrigin: [],
                    designatedContractingParty: '',
                    status: 0,
                    note: ''
                },
                formErrors: {
                    title: '',
                    owner: '',
                    applicationNumber: '',
                    applicationDate: '',
                    expiredOn: '',
                    officeOfOrigin: '',
                    generalError: '',
                    designatedCountry: '',
                    niceClasses: '',
                    status: ''
                },
                inValidDesignatedCountries: false,
                inValidNiceClasses: false,
                loading: false,
                loaders: {
                    brandData: false,
                    owners: true,
                    niceClasses: true
                },
                fileInputs: [],
                selectOptions: trademark_statuses
            }
        },
        mounted() {
            if (this.$store.getters.hasData('currentBrand') && this.id === this.$store.state.currentBrand.id.toString()) {
                this.fillEditData(this.$store.state.currentBrand);
            } else if (this.id.length) {
                this.loaders.brandData = true;
                this.$store.dispatch('brandDetails', this.id).then(response => {
                    this.loaders.brandData = false;
                    this.fillEditData(response);
                }).catch(() => {
                    this.loaders.brandData = false;
                });
            }
            this.$store.dispatch('owners').then(response => {
                this.owners = response;
                this.loaders.owners = false;
            }).catch(() => {
                this.loaders.owners = false;
            });
            this.$store.dispatch('niceClasses').then(response => {
                this.niceClasses = response;
                this.loaders.niceClasses = false;
            }).catch(() => {
                this.loaders.niceClasses = false;
            });
        },
        methods: {
            addNewRuleClick() {
                this.$refs.newRule.click()
            },
            fillEditData(data) {
                let niceClasses = [];
                let viennaClasses = [];

                data.nice_classes.forEach(item => {
                    niceClasses.push({value: item.class_num, description: item.description});
                });
                // {key: tag, value: tag}
                let title = []
                if (data.title) {
                    title = data.title.split(' ').map(item => {
                        return {key: item, value: item}
                    });
                }
                let designated_country = data.designated_country.map(item => {
                    return {key: item, value: item}
                });
                viennaClasses = data.vienna_classes.map(item => {
                    return {key: item.class_id, value: item.class_id}
                });

                this.countrySelect = this.$countries.find(obj => {
                   return obj.code === data.office_of_origin
                });

                this.formData = {
                    type: data.type,
                    kind: data.kind ? data.kind : 'Individual',
                    rules: data.rules ? data.rules : [],
                    deletedRules: [],
                    rule: [],
                    brandName: data.brand_name,
                    title: title,
                    owner: data.owner.id,
                    niceClasses: niceClasses,
                    viennaClasses: viennaClasses,
                    colors: data.colors,
                    trackTitle: data.track_title,
                    trackNice: data.track_nice,
                    trackVienna: data.track_vienna,
                    applicationNumber: data.application_number,
                    applicationDate: this.$options.filters.dateFormat(data.application_date),
                    registerNumber: data.register_number,
                    registrationDate: this.$options.filters.dateFormat(data.registration_date),
                    expiredOn: data.expired_on,
                    officeOfOrigin: data.office_of_origin,
                    designatedCountry: designated_country,
                    status: data.status,
                    note: data.note
                };

                this.uploadCollectiveFile = (data.kind && data.kind === 'Collective') ? true : false;

                // logo_path
                if (data.logo_path.length) {
                    this.imageBase64 = this.$store.state.baseUrl + data.logo_path;
                }
                this.isEdit = true;
            },
            showUploadCollectiveFile(show) {
                this.uploadCollectiveFile = show;
            },
            changeViennaClasses(event) {
                let symbolsArray = [';', ' ', ','];
                if (symbolsArray.includes(event.target.value[event.target.value.length - 1])) {
                    this.addToViennaClasses();
                }
            },
            addToViennaClasses() {
                let classString = this.viennaClasses;
                classString = classString.split(' ')[0];
                classString = classString.split(',')[0];
                classString = classString.split(';')[0];
                if (classString.length) {
                    this.formData.viennaClasses.push(classString);
                }
                this.viennaClasses = '';
            },
            removeViennaClass(index) {
                this.formData.viennaClasses.splice(index, 1);
            },
            changeClass(event, index) {
                this.formData.niceClasses[index].description = this.niceClasses[event.target.value];
            },
            removeNiceClass(index) {
                this.formData.niceClasses.splice(index, 1);
            },
            addNiceClass() {
                this.formData.niceClasses.push({value: null, description: ''});
            },
            openOwnersModal() {
                this.showOwnerModal = true;
            },
            closeOwnersModal(owner = null) {
                if (owner !== null) {
                    this.owners.push(owner);
                    this.formData.owner = owner.id;
                }
                this.showOwnerModal = false;
            },
            filesChange(event) {
                if (event.target.files[0]) {
                    let fileType = event.target.files[0].type;
                    this.fileDragOver = false;
                    if (fileType.includes('image')) {
                        let reader = new FileReader();
                        let file = event.target.files[0];
                        if (event.target.files[0]) {
                            reader.readAsDataURL(file);
                        }
                        reader.onloadend = () => {
                            this.imageBase64 = reader.result;
                        };
                    }
                }
            },
            deleteLogo() {
                if(confirm("Do you really want to delete?")){
                    this.$store.dispatch('deleteBrandLogo', {id: this.id}
                    ).then(() => {
                       this.imageBase64 = ''
                    });
                    this.imageBase64 = ''
                }
            },
            addNewRule(event) {
                if (event.target.files.length) {
                    this.fileInputs = [];
                    for (let i = 0; i < event.target.files.length; i++) {
                        this.fileInputs.push({name: event.target.files[i].name});
                    }
                }
            },
            deleteRule(id) {
                let deleteRuleIndex = this.formData.deletedRules.findIndex(item => {
                    return item === id;
                });
                if (deleteRuleIndex !== -1) {
                    this.formData.deletedRules.splice(deleteRuleIndex, 1);
                } else {
                    this.formData.deletedRules.push(id);
                }
            },
            inDeleteRules(id) {
                let deleteRuleIndex = this.formData.deletedRules.findIndex(item => {
                    return item === id;
                });
                return (deleteRuleIndex !== -1);
            },
            checkNiceClasses() {
                let that = this;
                this.formData.niceClasses.forEach((item, index) => {
                    if (item.value === "null" || item.value === null) {
                        that.removeNiceClass(index);
                    }
                });
            },
            validateDesignatedCountries() {
                if (!this.formData.designatedCountry.length) {
                    this.inValidDesignatedCountries = true;
                    return false
                } else {
                    this.inValidDesignatedCountries = false;
                    return true
                }
            },
            saveBrand() {
                if (!this.loading) {
                    this.formErrors = {
                        title: '',
                        owner: '',
                        applicationNumber: '',
                        applicationDate: '',
                        expiredOn: '',
                        officeOfOrigin: '',
                        generalError: '',
                        designatedCountry: '',
                        niceClasses: '',
                        status: ''
                    };

                    this.checkNiceClasses();

                    let validDC = this.validateDesignatedCountries();

                    this.$validator.validateAll().then((result) => {
                        if (validDC && result) {
                            this.loading = true;
                            let brandForm = new FormData(this.$refs.brandForm);
                            this.formData.niceClasses.forEach((item) => {
                                if (item.value !== "null" && item.value !== null) {
                                    brandForm.append('niceClasses[' + item.value + ']', item.description);
                                }
                            });
                            if (!this.formData.designatedCountry.length) {
                                brandForm.append('designatedCountry[]', this.formData.designatedCountry);
                            }
                            if (typeof this.formData.registrationDate === "object" && this.formData.registrationDate !== null) {
                                brandForm.set('registrationDate', this.formData.registrationDate.toJSON());
                            }
                            if (typeof this.formData.applicationDate === "object" && this.formData.applicationDate !== null) {
                                brandForm.set('applicationDate', this.formData.applicationDate.toJSON());
                            }
                            if (typeof this.formData.expiredOn === "object" && this.formData.expiredOn !== null) {
                                brandForm.set('expiredOn', this.formData.expiredOn.toJSON());
                            }
                            brandForm.set('trackTitle', this.formData.trackTitle ? '1' : '0');
                            brandForm.set('trackNice', this.formData.trackNice ? '1' : '0');
                            brandForm.set('trackVienna', this.formData.trackVienna ? '1' : '0');
                            brandForm.append('active', (this.formData.trackTitle || this.formData.trackNice || this.formData.trackVienna) ? '1' : '0');
                            this.formData.deletedRules.forEach(rule => {
                                brandForm.append('deletedRules[]', rule);
                            });
                            let data = {};
                            let apiCall = '';
                            if (this.id.length) {
                                data = {id: this.id, data: brandForm};
                                apiCall = 'editBrand';
                            } else {
                                data = brandForm;
                                apiCall = 'postBrand';
                            }
                            this.$store.dispatch(apiCall, data).then(response => {
                                this.loading = false;
                                this.$router.push(`/dashboard/brand/${response.id}`);
                            }).catch(error => {
                                if (error.status === 400) {
                                    error.data.forEach(obj => {
                                        this.formErrors[obj.property_path] = obj.message;
                                    });
                                } else {
                                    this.formErrors.generalError = 'error';
                                }
                                this.loading = false;
                            });
                        }
                    });
                }
            },
            customFormatter(date) {
                return moment(date).format('YYYY-MM-DD');
            },
            countrySelectCustom({name, code}) {
                return `${name} (${code})`
            }
        }
    }
</script>

<style scoped>
    .qf-items-box {
        border: 1px solid black;
        border-radius: 10px;
    }

    .qf-upload-file-box {
        display: inline-block;
    }

    /*select.form-control.qf-h-100px:not([size]):not([multiple]) {*/
    /*height: 100px;*/
    /*}*/


    .inputfile {
        width: 0.1px;
        height: 0.1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
    }

    .inputfile:focus + label {
        outline: 1px dotted #000;
        outline: -webkit-focus-ring-color auto 5px;
    }

    .inputfile + label * {
        pointer-events: none;
    }

    .qf-custom-icon-btn {
        -webkit-appearance: none;
        background-color: transparent;
        border: none;
        color: #002e42;
    }

    .qf-custom-icon-btn:hover {
        color: #4D7B8F;
        cursor: pointer;
    }

    .qf-rule-label {
        margin-bottom: 0;
        margin-right: 5px;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 140px;
        white-space: nowrap;
        outline: 0 !important;
    }

    .qf-rule-label.active.focus,
    .qf-rule-label.active:focus,
    .qf-rule-label.focus,
    .qf-rule-label.focus:active,
    .qf-rule-label:active:focus,
    .qf-rule-label:focus {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
    }

    .qf-non-clickable {
        cursor: default;
    }

    hr {
        border-top-color: #002e42;
    }

    .qf-icon-separator {
        margin: -12px 10px;
        width: 1px;
        background: #211f20;
        display: inline-block;
        height: 36px;
        transition: 0.15s all ease-in-out;
    }

    .btn-outline-dark:hover .qf-icon-separator {
        background: #ffffff;
    }

    .qf-dropzone {
        height: 269px;
    }

    .text-center .delete-icon{
        overflow: visible;
        position: absolute;
        top: 20px;
        right: 20px;
        z-index: 999999;
    }


</style>
